export const GET_EMAILS_TEMPLATE = 'email/GET_EMAILS_TEMPLATE'

export const UPDATE_EMAILS_CACHE = 'email/UPDATE_EMAILS_CACHE'
export const UPDATE_EMAILS_CACHE_SET = 'email/UPDATE_EMAILS_CACHE_SET'
export const UPDATE_EMAIL_SEARCH_RESULTS = 'email/UPDATE_EMAIL_SEARCH_RESULTS'

export function getEmailsTemplate(payload) {
  return { type: GET_EMAILS_TEMPLATE, payload: payload }
}
